// Development environment configuration

export interface Environment {
  graphqlEndpoint: string;
  environment: string;
  posthogKey: string;
  posthogHost: string;
  posthogEnabled: boolean;
  // Base URL the desktop app downloads Cowork skills from (frontend origin).
  skillsBaseUrl: string;
}

export const environment: Environment = {
  graphqlEndpoint: process.env.DEV_GRAPHQL_ENDPOINT || 'https://dev.gk.ignosistech.in/v1/graphql',
  environment: 'development',
  posthogKey: 'phc_kOberlZkPR91VRjmsa4p7Opk9xyvpDAb1OnTeOtACxS',
  posthogHost: 'https://dev.gk.ignosistech.in/ingest',
  posthogEnabled: false,
  skillsBaseUrl: process.env.DEV_SKILLS_BASE_URL || 'https://dev.gk.ignosistech.in',
};
